import { IAssembleiaAssociadoPautaVoto } from 'store/modules/AssembleiasAssociadoReducer';

import { post } from './methods';

interface RepresentanteChapa {
  associado: string;
  idCargo: number;
  idRepresentanteChapa: number;
  nomeCargo:
    | 'DESCONHECIDO'
    | 'PRESIDENTE'
    | 'VICE_PRESIDENTE'
    | 'CONSELHEIRO'
    | 'CONSELHEIRO_EFETIVO'
    | 'CONSELHEIRO_SUPLENTE';
}

export interface ItemPautaResponse {
  descricao: string;
  flgAbstencao: number;
  idItemPauta: number;
  quantidadeVotos: number;
  representantesChapa: Array<RepresentanteChapa>;
}

export type PautaResponse = {
  itens: Array<ItemPautaResponse>;
  flagDeclaracaoSemVotos: boolean;
};

const votoPresencial = {
  inserirVotosCPF: (cpf: string, idItemPauta: number) => {
    const endpoint = `voto-presencial/associado/${cpf}/item/${idItemPauta}`;
    return post<IAssembleiaAssociadoPautaVoto[]>(endpoint);
  },
};

export default votoPresencial;
